module.exports = __webpack_public_path__ + "img/tablet-VTA-VALORACION-MODIFICAR01.30230325.png";